import React from 'react'
import PropTypes from 'prop-types';
import JEDZ from './jedz/JEDZ';

function Index(
    {
        expanded,
    }) {
    return expanded && <JEDZ />
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;